import { SmartTable } from '../../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, UsersResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.UsersResource = UsersResource;
        this.Alert = Alert;
    }

    $onInit() {
        if (!this.accounts.length) {
            this.$state.go('^', {}, {location: 'replace'})
        }
        this.st = new SmartTable();
    }
    search() {
        this.spAlert = null;
        this.selectedCompanyUser = null;
        this.isSearching = true;

        this.UsersResource
            .getCompanyUserForSaaspassUser(this.companyId,this.searchText)
            .then((companyUser) => {
                    this.selectedCompanyUser = companyUser;
                }
            )
            .catch((response) => {
                if (response.status === 404) {
                    this.Alert('danger', 'company.user-directories.manage-account.verify.user-not-found', false);
                }
            })
            .finally(() => this.isSearching = false);
    }

    move() {
        const accounts = this.accountsForCompanyUser;
        const accountIds = this.accounts.map(({id}) => id);;
        this.isSaving = true;
        this.AccountsResource.bulkMoveCompanySharedAccount(this.companyId,this.companyUser.id,this.selectedCompanyUser,accountIds)
            .then(() => {
                this.Alert('success', 'company.user-directories.manage-user.move-accounts.moved');
                if (accounts.length) {
                    this.$state.go('^', {}, {reload: true});
                } else {
                    // When all accounts are deleted, company user is also deleted
                    this.$state.go('company.user-directories.saaspass-users', {}, {reload: true});
                }
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/move-shared-accounts/move-shared-accounts.controller.js